<template>
  <ms-dynamic-popup
    title="Tham số in chứng từ"
    classTitle="report-param-title"
    :width="900"
    dockPosition="right"
    @beforeOpen="beforeOpen($event, close)"
    @beforeClose="beforeClose"
    classDetail="report-param-c202bNSND112020-withBankAccount"
    @shortkeyAction="shortkeyAction"
    :name="'C202bNSND112020_WithBankAccount_Offline'"
    ><template v-slot:icon>
      <a
        class="button icon24 ic-question mr-2"
        v-tooltip="'Trợ giúp'"
        shortkey-target="Help"
        target="_blank"
        :href="linkHelp($ms.constant.Help.VoucherReport)"
      ></a>
    </template>
    <template v-slot:content>
      <div class="flex flex-column">
        <div class="report-title mt-1 ml-3 mr-3">
          <div class="d-flex">
            <div class="title-control-group" :class="{active: selectedTabMain == 1}" @click="selectedTabMainHandler(1)">
              Thông tin chung
            </div>
            <div class="title-control-group" :class="{active: selectedTabMain == 2}" @click="selectedTabMainHandler(2)">
              Thanh toán
            </div>
            <div class="title-control-group" :class="{active: selectedTabMain == 3}" @click="selectedTabMainHandler(3)">
              KBNN ghi
            </div>
            <div class="title-control-group" :class="{active: selectedTabMain == 4}" @click="selectedTabMainHandler(4)">
              Cách hiển thị
            </div>
          </div>
        </div>
        <div class="report-body flex1 ml-3 mr-3">
          <div class="report-tab tab-1" v-show="selectedTabMain == 1">
            <div class="flex-row mt-1" v-show="caseRefType1">
              <div class="flex1">
                <div class="control-title">
                  <label class="label">Tài khoản</label>
                </div>
                <ms-combobox
                  class="flex mt-1"
                  displayField="bank_account"
                  valueField="bank_account"
                  v-model="model.bank_account"
                  v-model:display="model.bank_account"
                  :initText="model.bank_account"
                  quickSearch="BankInfoQuickSearch"
                  :dropdownWidth="600"
                  isReload
                  :data="comboboxDataRemote.bankInfo"
                  :columns="bankInfoColumns"
                  :queryMode="'remote'"
                  :remoteFilter="true"
                  @comboboxLoadData="
                    payload =>
                      onBankInfoComboboxLoadData(payload, null, {
                        dataField: 'bankInfo',
                      })
                  "
                  @selected="
                    ({newData}) => {
                      selectedBank({newData}, this);
                    }
                  "
                ></ms-combobox>
              </div>
              <div class="flex1 ml-2">
                <div class="control-title">
                  <label class="label" title="Chương trình mục tiêu">CTMT</label>
                </div>
                <ms-combobox
                  class="flex mt-1"
                  displayField="project_code"
                  valueField="project_id"
                  quickSearch="ProjectQuickSearch"
                  :quickSearchParam="quickSearchParam.Project"
                  v-model="model.project_id"
                  v-model:display="model.project_code"
                  :initText="model.project_code"
                  :dropdownWidth="600"
                  isReload
                  :data="comboboxDataRemote.project"
                  :columns="projectColumns"
                  :queryMode="'remote'"
                  :remoteFilter="true"
                  @comboboxLoadData="
                    payload =>
                      onProjectCommonComboboxLoadData(
                        customPayloadProject(payload),
                        null,
                        {
                          dataField: 'project',
                        },
                        addDataCombo('project'),
                      )
                  "
                  @selected="
                    ({newData}) => {
                      selectedProject({newData}, this);
                    }
                  "
                ></ms-combobox>
              </div>
            </div>
            <div class="flex-row mt-1">
              <div class="flex1">
                <div class="control-title label">
                  <label class="label">Hình thức thanh toán</label>
                </div>
                <ms-combobox-enum
                  class="flex1 mt-1"
                  :forceSelection="false"
                  enum="PaymentMethod"
                  v-model="model.PaymentMethod"
                  :initText="
                    $ms.format.formatData(model.PaymentMethod, {
                      formatType: 100,
                      enumName: 'PaymentMethod',
                    })
                  "
                  :rules="[
                    {name: $ms.constant.ValidateRule.Required},
                    {name: $ms.constant.ValidateRule.ForceSelection},
                  ]"
                ></ms-combobox-enum>
              </div>
              <div class="d-flex flex1 ml-2">
                <div class="flex1">
                  <div class="control-title">
                    <label class="label" title="Số cam kết chi, Hợp đồng khung">Số CKC, HĐK</label>
                  </div>
                  <ms-input v-model="model.contract_template" :maxLength="50" :trimModel="true" class="mt-1"></ms-input>
                </div>
                <div class="flex1 ml-2">
                  <div class="control-title">
                    <label class="label" title="Số cam kết chi, Hợp đồng thực hiện">Số CKC, HĐTH</label>
                  </div>
                  <ms-input v-model="model.contract_perform" :maxLength="50" :trimModel="true" class="mt-1"></ms-input>
                </div>
              </div>
            </div>

            <div class="flex-row mt-1">
              <div class="flex-column flex1">
                <div class="flex-row">
                  <ms-checkbox label="Phát hành séc" v-model="model.use_sec" class="mb-1 left"></ms-checkbox>
                </div>
                <div class="flex-row">
                  <ms-input v-model="addSecInfo" :maxLength="255" :disabled="!model.use_sec"></ms-input>
                </div>
              </div>
              <div class="flex-column flex1 ml-2">
                <div class="flex-row">
                  <ms-checkbox label="Thông tin bổ sung" v-model="model.use_add_info" class="mb-1 left"></ms-checkbox>
                </div>
                <div class="flex-row">
                  <ms-input v-model="model.add_info" :maxLength="255" :disabled="!model.use_add_info"></ms-input>
                </div>
              </div>
            </div>
            <div class="flex-row mt-1">
              <div class="mt-1 seperator-line"></div>
            </div>
            <div class="flex-row mt-1">
              <div class="flex3">
                <div class="control-title">
                  <label class="label">Tên đơn vị (Người nộp thuế)</label>
                </div>
                <ms-input
                  v-model="model.company_name"
                  :maxLength="255"
                  class="mt-1"
                  :rules="
                    isPrintGrid && totalTaxAmount > 0 ? [{name: $ms.constant.ValidateRule.Required, hide: true}] : []
                  "
                  ignoreValidate
                ></ms-input>
              </div>
              <div class="flex2 ml-2">
                <div class="control-title">
                  <label class="label">Mã số thuế</label>
                </div>
                <ms-input
                  v-model="model.company_tax_code"
                  :maxLength="20"
                  class="mt-1"
                  :rules="
                    isPrintGrid && totalTaxAmount > 0 ? [{name: $ms.constant.ValidateRule.Required, hide: true}] : []
                  "
                  ignoreValidate
                ></ms-input>
              </div>
            </div>
            <div class="flex-row mt-1">
              <div class="flex3 flex-row">
                <div class="flex2">
                  <div class="control-title">
                    <label class="label" title="Mã nội dung kinh tế">Mã NDKT</label>
                  </div>
                  <ms-input
                    v-model="model.NDKT_code"
                    :maxLength="20"
                    class="mt-1"
                    :rules="
                      isPrintGrid && totalTaxAmount > 0 ? [{name: $ms.constant.ValidateRule.Required, hide: true}] : []
                    "
                    ignoreValidate
                  ></ms-input>
                </div>
                <div class="flex1 ml-2">
                  <div class="control-title">
                    <label class="label">Mã chương</label>
                  </div>
                  <ms-input
                    v-model="model.budget_chapter_code"
                    :maxLength="20"
                    class="mt-1"
                    :rules="
                      isPrintGrid && totalTaxAmount > 0 ? [{name: $ms.constant.ValidateRule.Required, hide: true}] : []
                    "
                    ignoreValidate
                  ></ms-input>
                </div>
              </div>
              <div class="flex2 ml-2">
                <div class="control-title">
                  <label class="label">Kỳ thuế</label>
                </div>
                <ms-input
                  class="mt-1"
                  v-model="model.tax_period"
                  :maxLength="20"
                  :rules="
                    isPrintGrid && totalTaxAmount > 0 ? [{name: $ms.constant.ValidateRule.Required, hide: true}] : []
                  "
                  ignoreValidate
                ></ms-input>
              </div>
            </div>
            <div class="flex-row mt-1">
              <div style="width: 324px">
                <div class="control-title">
                  <label class="label" title="Mã cơ quan thu">Mã CQ thu</label>
                </div>

                <ms-combobox
                  ref="collectionAgencyCombo"
                  class="flex mt-1"
                  displayField="code"
                  valueField="code"
                  v-model="model.collection_agency_code"
                  v-model:display="model.collection_agency_code"
                  :initText="model.collection_agency_code"
                  :dropdownWidth="600"
                  isReload
                  :data="collectionAgencyData"
                  :quickSearchParam="quickSearchParam.collectionAgency"
                  :columns="collectionAgencyColumns"
                  :queryMode="'local'"
                  @selected="
                    ({newData}) => {
                      selectedCollectionAgency({newData}, this);
                    }
                  "
                  @update:modelValue="inputCollectionAgency"
                  :rules="[{name: $ms.constant.ValidateRule.Required, hide: true}]"
                />
              </div>
              <div class="ml-2 flex1">
                <div class="control-title">
                  <label class="label">Cơ quan quản lý thu</label>
                </div>
                <ms-input
                  v-model="model.collection_agency_name"
                  :maxLength="255"
                  class="mt-1"
                  :rules="
                    isPrintGrid && totalTaxAmount > 0 ? [{name: $ms.constant.ValidateRule.Required, hide: true}] : []
                  "
                  ignoreValidate
                ></ms-input>
              </div>
            </div>
            <div class="flex-row mt-1">
              <div style="width: 324px">
                <div class="control-title">
                  <label class="label" title="Mã kho bạc nhà nước">Mã KBNN</label>
                </div>
                <ms-combobox
                  ref="stateBankCombo"
                  class="flex mt-1"
                  displayField="state_bank_code"
                  valueField="state_bank_code"
                  v-model="model.state_bank_code"
                  v-model:display="model.state_bank_code"
                  :initText="model.state_bank_code"
                  :dropdownWidth="600"
                  isReload
                  :data="stateBankData"
                  :columns="stateTreasuryColumns"
                  :queryMode="'local'"
                  :isFreeText="true"
                  :quickSearchParam="quickSearchParam.StateBank"
                  @selected="
                    ({newData}) => {
                      selectedStateTreasury({newData}, this);
                    }
                  "
                  :rules="
                    isPrintGrid && totalTaxAmount > 0 ? [{name: $ms.constant.ValidateRule.Required, hide: true}] : []
                  "
                ></ms-combobox>
              </div>
              <div class="flex1 ml-2">
                <div class="control-title">
                  <label class="label" title="Kho bạc nhà nước hạch toán khoản thu">KBNN hạch toán khoản thu</label>
                </div>
                <ms-input
                  v-model="model.state_bank_name"
                  :maxLength="255"
                  class="mt-1"
                  :rules="
                    isPrintGrid && totalTaxAmount > 0 ? [{name: $ms.constant.ValidateRule.Required, hide: true}] : []
                  "
                  ignoreValidate
                ></ms-input>
              </div>
            </div>

            <div class="flex-row mt-1" v-show="caseRefType2">
              <div class="mt-1 seperator-line"></div>
            </div>
            <div class="flex-row mt-1" v-show="caseRefType2">
              <div style="width: 324px">
                <div class="control-title">
                  <label class="label">Tên đơn vị nhận tiền</label>
                </div>
                <ms-combobox
                  class="flex mt-1 mr-2"
                  valueField="accounting_object_id"
                  displayField="accounting_object_code"
                  v-model="model.organization_id"
                  v-model:display="model.organization_code"
                  @selected="
                    ({newData}) => {
                      selectedOrganization({newData}, this);
                    }
                  "
                  :initText="model.organization_code"
                  :dropdownWidth="600"
                  :data="comboboxDataRemote.organization"
                  :columns="accountingObjectCustomColumns"
                  :queryMode="'remote'"
                  :remoteFilter="true"
                  @comboboxLoadData="
                    payload =>
                      onAccountingObjectComboboxLoadData(payload, null, {
                        dataField: 'organization',
                      })
                  "
                ></ms-combobox>
              </div>
              <div class="flex2 ml-2">
                <div class="control-title">
                  <label class="label">&nbsp;</label>
                </div>
                <ms-input class="mt-1" v-model="model.organization_name" :maxLength="255" :disabled="true"></ms-input>
              </div>
            </div>
            <div class="flex-row mt-1" v-show="caseRefType2">
              <div style="width: 324px">
                <div class="control-title">
                  <label class="label">Người nhận tiền</label>
                </div>
                <ms-combobox
                  class="flex mt-1 mr-2"
                  valueField="accounting_object_id"
                  displayField="accounting_object_code"
                  v-model="model.accounting_object_id"
                  v-model:display="model.accounting_object_code"
                  @selected="
                    ({newData}) => {
                      selectedAccountingObject({newData}, this);
                    }
                  "
                  :initText="model.accounting_object_code"
                  :dropdownWidth="600"
                  :data="comboboxDataRemote.accountingObject"
                  :columns="accountingObjectCustomColumns"
                  :queryMode="'remote'"
                  :remoteFilter="true"
                  @comboboxLoadData="
                    payload =>
                      onAccountingObjectComboboxLoadData(payload, null, {
                        dataField: 'accountingObject',
                      })
                  "
                ></ms-combobox>
              </div>
              <div class="flex2 ml-2">
                <div class="control-title">
                  <label class="label">&nbsp;</label>
                </div>
                <ms-input
                  class="mt-1"
                  v-model="model.accounting_object_name"
                  :maxLength="255"
                  :disabled="true"
                ></ms-input>
              </div>
            </div>
          </div>
          <div class="report-tab tab-2" v-show="selectedTabMain == 2">
            <div class="flex-row mt-2">
              <div class="control-title">
                <label class="label" style="font-sixe: 14px">Nhập thanh toán</label>
              </div>
            </div>
            <ms-grid-editor
              ref="Details"
              :data="details"
              class="flex-box flex1 mt-2"
              v-model:list="details"
              idField="ref_detail_id"
              greyTitle
              :footer="true"
              @updateBusiness="changeDataBusiness"
              :changeTriggers="['tax_amount', 'payment_amount']"
              :lockable="false"
              :sortable="false"
              :columns="model.columnDetails"
              :filterable="true"
              titleFooter="Tổng"
            ></ms-grid-editor>
          </div>
          <div class="report-tab tab-3" v-show="selectedTabMain == 3">
            <div class="title-3 flex-row mt-1" @click="changeTab3GroupTax">
              <div class="icon-combo--dropdown" :class="[tab3_group_tax ? 'expand' : '']"></div>
              <div class="title-text">Nộp thuế</div>
            </div>
            <div v-show="tab3_group_tax">
              <div class="flex-column mt-1">
                <div class="flex-row flex1">
                  <div class="flex1">
                    <div class="control-title">
                      <label class="label" title="Nợ tài khoản">Nợ TK</label>
                    </div>
                    <ms-input v-model="model.debit_account_tax_1" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                  <div class="flex1 ml-2">
                    <div class="control-title">
                      <label class="label" title="Có tài khoản">Có TK</label>
                    </div>
                    <ms-input v-model="model.credit_account_tax_1" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                  <div class="flex1 ml-2">
                    <div class="control-title">
                      <label class="label" title="Nợ tài khoản">Nợ TK</label>
                    </div>
                    <ms-input v-model="model.debit_account_tax_2" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                  <div class="flex1 ml-2">
                    <div class="control-title">
                      <label class="label" title="Có tài khoản">Có TK</label>
                    </div>
                    <ms-input v-model="model.credit_account_tax_2" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                </div>
              </div>
              <div class="flex-column mt-1">
                <div class="flex-row flex1">
                  <div class="flex1">
                    <div class="control-title">
                      <label class="label" title="Nợ tài khoản">Nợ TK</label>
                    </div>
                    <ms-input v-model="model.debit_account_tax_3" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                  <div class="flex1 ml-2">
                    <div class="control-title">
                      <label class="label" title="Có tài khoản">Có TK</label>
                    </div>
                    <ms-input v-model="model.credit_account_tax_3" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                  <div class="flex1 ml-2">
                    <div class="control-title">
                      <label class="label" title="Mã cơ quan thu">Mã CQ thu</label>
                    </div>
                    <ms-input v-model="model.collection_agency_tax_code" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                  <div class="flex1 ml-2">
                    <div class="control-title">
                      <label class="label" title="Mã địa bàn hành chính">Mã ĐBHC</label>
                    </div>
                    <ms-input v-model="model.tax_payer_organization_code" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="title-3 flex-row mt-1" @click="changeTab3ReturnOrg">
              <div class="icon-combo--dropdown" :class="[tab3_return_org ? 'expand' : '']"></div>
              <div class="title-text">Trả đơn vị hưởng</div>
            </div>
            <div v-show="tab3_return_org">
              <div class="flex-column mt-1">
                <div class="flex-row flex1">
                  <div class="flex1">
                    <div class="control-title">
                      <label class="label" title="Nợ tài khoản">Nợ TK</label>
                    </div>
                    <ms-input v-model="model.debit_account_1" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                  <div class="flex1 ml-2">
                    <div class="control-title">
                      <label class="label" title="Có tài khoản">Có TK</label>
                    </div>
                    <ms-input v-model="model.credit_account_1" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                  <div class="flex1 ml-2">
                    <div class="control-title">
                      <label class="label" title="Nợ tài khoản">Nợ TK</label>
                    </div>
                    <ms-input v-model="model.debit_account_2" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                  <div class="flex1 ml-2">
                    <div class="control-title">
                      <label class="label" title="Có tài khoản">Có TK</label>
                    </div>
                    <ms-input v-model="model.credit_account_2" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                </div>
              </div>
              <div class="flex-column mt-1">
                <div class="flex-row flex1">
                  <div class="flex1">
                    <div class="control-title">
                      <label class="label" title="Nợ tài khoản">Nợ TK</label>
                    </div>
                    <ms-input v-model="model.debit_account_3" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                  <div class="flex1 ml-2">
                    <div class="control-title">
                      <label class="label" title="Có tài khoản">Có TK</label>
                    </div>
                    <ms-input v-model="model.credit_account_3" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                  <div class="flex1 ml-2">
                    <div class="control-title">
                      <label class="label" title="Mã địa bàn hành chính">Mã ĐBHC</label>
                    </div>
                    <ms-input v-model="model.DBHC_code" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                  <div class="flex1 ml-2"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="report-tab tab-4" v-show="selectedTabMain == 4">
            <div class="flex-row mt-1">
              <ms-checkbox label="Cỡ chữ" v-model="model.has_font_size" class="left"></ms-checkbox>
              <div class="ml-2" style="width: 70px">
                <ms-number
                  v-model="model.font_size"
                  :max="12"
                  :min="6"
                  :step="1"
                  spin
                  :disabled="!model.has_font_size"
                ></ms-number>
              </div>
            </div>
            <div class="flex-row mt-1">
              <div class="seperator-line tab-3"></div>
            </div>
            <div class="flex-row mt-1">
              <ms-checkbox
                class="flex1 left"
                label="Cộng gộp các bút toán giống nhau"
                v-model="model.is_summary_same"
                v-if="false"
              ></ms-checkbox>
              <ms-checkbox
                class="flex1 left"
                label="Không lặp lại thông tin trùng nhau"
                v-model="model.not_repeat_duplicate"
              ></ms-checkbox>
            </div>
            <div class="flex-row mt-1" v-if="false">
              <ms-checkbox
                class="flex1 left"
                label="Lặp lại tiêu đề và chữ ký ở mỗi trang"
                v-model="model.repeat_title_signature"
              ></ms-checkbox>
              <ms-checkbox
                class="flex1 ml-2"
                label="Trang sau hạ thấp 1/4 trang"
                v-model="model.lower_aquater_page"
                :disabled="model.repeat_title_signature"
              ></ms-checkbox>
            </div>
            <div class="flex-row mt-1" v-if="false">
              <div class="flex1 align-center flex-row">
                <div>Số dòng hiển thị trên 1 trang</div>
                <div class="ml-2" style="width: 70px">
                  <ms-number
                    v-model="model.row_per_page"
                    :max="16"
                    :min="1"
                    :step="1"
                    spin
                    :disabled="!model.repeat_title_signature"
                  ></ms-number>
                </div>
              </div>
              <div class="flex1 align-center ml-2 flex-row">
                <div>Số dòng trống hiển thị ở trang cuối</div>
                <div class="ml-2" style="width: 70px">
                  <ms-number
                    v-model="model.add_empty_row"
                    :max="16"
                    :min="0"
                    :step="1"
                    spin
                    :disabled="!model.repeat_title_signature"
                    :rules="[{name: $ms.constant.ValidateRule.Required}]"
                    keepZero
                  ></ms-number>
                </div>
              </div>
            </div>
            <div class="flex-row mt-1">
              <div class="seperator-line tab-3"></div>
            </div>
            <div class="flex-row mt-1">
              <div class="flex1">
                <div class="control-title label">
                  <label class="label">Nội dung thanh toán là</label>
                </div>
                <ms-combobox-enum
                  class="flex1 mt-1"
                  :forceSelection="false"
                  enum="PaymentContent"
                  v-model="model.payment_content"
                  :initText="
                    $ms.format.formatData(model.payment_content, {
                      formatType: 100,
                      enumName: 'PaymentContent',
                    })
                  "
                  selectOnly
                ></ms-combobox-enum>
              </div>
              <div class="flex1 ml-2"></div>
            </div>
            <div class="flex-row mt-1" v-if="false">
              <div class="seperator-line tab-3"></div>
            </div>

            <div class="flex-row mt-1" v-if="false">
              <div class="flex-column flex1">
                <div class="flex-row">
                  <ms-checkbox label="Bổ sung dòng cộng theo" v-model="model.add_row" class="left"></ms-checkbox>
                </div>
                <div class="flex-row mt-1">
                  <div class="flex-row flex1 align-center">
                    <ms-combobox-enum
                      class="flex1"
                      :forceSelection="false"
                      enum="AddGroup"
                      v-model="model.add_group"
                      :initText="
                        $ms.format.formatData(model.add_group, {
                          formatType: 100,
                          enumName: 'AddGroup',
                        })
                      "
                      :disabled="!model.add_row"
                      selectOnly
                    ></ms-combobox-enum>
                    <ms-combobox-enum
                      class="flex1 ml-2"
                      :forceSelection="false"
                      enum="AddShow"
                      v-model="model.add_show"
                      :initText="
                        $ms.format.formatData(model.add_show, {
                          formatType: 100,
                          enumName: 'AddShow',
                        })
                      "
                      :disabled="!model.add_row"
                      selectOnly
                    ></ms-combobox-enum>
                  </div>
                  <div class="flex1 ml-2">
                    <ms-checkbox
                      label="Hiển thị khi có 2 dòng trở lên"
                      v-model="model.show_min_two_row"
                      :disabled="!model.add_row"
                    ></ms-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-row mt-1" v-if="false">
              <div class="seperator-line tab-3"></div>
            </div>
            <div class="flex-row mt-1" v-if="false">
              <div class="flex-column flex1">
                <div class="flex-row">
                  <ms-checkbox
                    label="Hiển thị thêm dòng"
                    v-model="model.show_add_row"
                    class="left"
                    @change="changeShowRow"
                  ></ms-checkbox>
                </div>
                <div class="flex-row mt-1 align-center">
                  <div class="flex-row flex1">
                    <ms-combobox-enum
                      class="flex1"
                      :forceSelection="false"
                      enum="ShowRow"
                      v-model="model.show_row"
                      :initText="
                        $ms.format.formatData(model.show_row, {
                          formatType: 100,
                          enumName: 'ShowRow',
                        })
                      "
                      :disabled="!model.show_add_row"
                      selectOnly
                    ></ms-combobox-enum>
                    <ms-combobox-enum
                      class="flex1 ml-2"
                      :forceSelection="false"
                      enum="AddShow"
                      v-model="model.add_show_row"
                      :initText="
                        $ms.format.formatData(model.add_show_row, {
                          formatType: 100,
                          enumName: 'AddShow',
                        })
                      "
                      :disabled="!model.show_add_row"
                      selectOnly
                    ></ms-combobox-enum>
                  </div>
                  <div class="flex1 ml-2">lên cột nội dung</div>
                </div>
              </div>
            </div>
            <div class="flex-row mt-1 align-center" v-if="false">
              <div>đồng thời hiển thị thêm</div>
              <ms-checkbox
                label="Mã chương"
                v-model="model.show_budget_chapter_code"
                class="ml-2"
                :disabled="!model.show_add_row"
              ></ms-checkbox>
              <ms-checkbox
                label="Mã ngành KT"
                v-model="model.show_branch_KT_code"
                class="ml-2"
                :disabled="!model.show_add_row"
              ></ms-checkbox>
              <ms-checkbox
                label="Mã nguồn NSNN"
                v-model="model.show_soure_NSNN_code"
                class="ml-2"
                :disabled="!model.show_add_row"
              ></ms-checkbox>
            </div>
            <div class="flex-row mt-1 mb-1" v-if="IsDetailbyBudgetProvidence && false">
              <ms-checkbox
                label="Nhóm dữ liệu theo tính chất nguồn và mã dự phòng"
                v-model="model.is_group_budget_provide"
                class="left"
                @change="changeGroupDate"
              ></ms-checkbox>
            </div>
            <div class="flex-row mt-1 mb-1" v-if="false">
              <ms-checkbox
                label="Gộp chung các tính chất nguồn trên một giấy rút"
                v-model="model.is_summary_budget_property"
                class="left"
              ></ms-checkbox>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer="{close}">
      <div class="h-100 flex-between flex1">
        <div></div>
        <div class="d-flex" style="flex-direction: row-reverse">
          <ms-button text="Đồng ý" @click="commandClick($ms.constant.Command.Ok)"></ms-button>
          <ms-button
            text="Hủy"
            type="outline-button"
            v-tooltip="'Hủy (Ctrl + H)'"
            shortkey-target="Cancel"
            hasBorder
            @click="close"
            style="margin-right: 10px"
          ></ms-button>
        </div>
      </div>
    </template>
  </ms-dynamic-popup>
</template>

<script>
import {defineComponent, getCurrentInstance, reactive, ref, onMounted, watch, computed, nextTick} from 'vue';
import baseVoucherReportParam from '@/views/base/baseVoucherReportParam';
import {ModuleContext} from '@/stores/moduleConst';
import {mapGetters} from 'vuex';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil';
import api from '@/apis/report/voucherReportPrintAPI';
import {showError} from '@/commons/globalMessage';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import {useInforCommons} from '@/views/utility/commons/inforCommons.js';
import {useRemoteCombobox} from '@/setup/remoteCombobox.js';
import {useInitActionCombo} from '../../../../commons/combobox/initActionCombo.js';
import {useComboboxColumns} from '@/commons/combobox/comboboxColumns';
import OperationUtil from '@/commons/operationUtil';
import {usefilterActionCombo} from '@/commons/combobox/filterActionCombo.js';
import DVCFileAPI from '@/apis/dvc/dVCFileAPI.js';
import accountingObjectInfoAPI from '@/apis/di/accountingObjectInfoAPI.js';
import reportListAPI from '@/apis/report/reportListAPI.js';
import _ from 'lodash';
import {useSortDataVoucherReportData} from '@/views/report/parameters/voucherReport/SortDataVoucherReport/SortDataVoucherReportData.js';
import indexedDB from '@/commons/indexedDB';

export default defineComponent({
  components: {
    msGridEditor,
  },
  extends: baseVoucherReportParam,
  setup() {
    const {proxy} = getCurrentInstance();
    const comboboxDataRemote = reactive({});
    const model = reactive({
      PaymentMethod: null,
      contract_template: null,
      contract_perform: null,
      use_sec: false,
      add_sec_info: 'Yêu cầu phát hành sec cho',
      use_add_info: false,
      add_info: null,
      company_name: null,
      company_tax_code: null,
      NDKT_code: null,
      budget_chapter_code: null,
      tax_period: null,
      collection_agency_code: null,
      collection_agency_code: null,
      state_bank_name: null,
      state_bank_code: null,
      debit_account_tax_1: null,
      credit_account_tax_1: null,
      debit_account_tax_2: null,
      credit_account_tax_2: null,
      debit_account_tax_3: null,
      credit_account_tax_3: null,
      collection_agency_tax_code: null,
      tax_payer_organization_code: null,
      debit_account_1: null,
      credit_account_1: null,
      debit_account_2: null,
      credit_account_2: null,
      debit_account_3: null,
      credit_account_3: null,
      DBHC_code: null,
      has_font_size: false,
      font_size: 12,
      is_summary_same: false,
      not_repeat_duplicate: false,
      repeat_title_signature: true,
      lower_aquater_page: false,
      row_per_page: 10,
      add_empty_row: 2,
      payment_content: 'description',
      add_row: false,
      add_group: 'budget_sub_item_code',
      add_show: 1,
      show_min_two_row: false,
      show_add_row: false,
      show_row: 1,
      add_show_row: 1,
      show_budget_chapter_code: false,
      show_branch_KT_code: false,
      show_soure_NSNN_code: false,
      is_group_budget_provide: false,
      organization_code: null,
      organization_name: null,
      accounting_object_code: null,
      accounting_object_name: null,
      project_code: null,
      project_name: null,
      bank_account: null,
      is_summary_budget_property: true,
    });
    const {columnC202a} = useSortDataVoucherReportData();
    const reportIdCommon = 'C202b_ND11';
    const addSecInfo = ref('Yêu cầu phát hành sec cho');

    const collectionAgencyData = ref([]);

    const stateBankData = ref([]);

    const isPrintGrid = ref(false);

    proxy._gridDetails = {
      details: 'Details',
    };
    const tab3_group_tax = ref(true);
    const tab3_return_org = ref(true);

    const selectedTabMain = ref(1);
    const selectedTabMainHandler = value => {
      selectedTabMain.value = value;
      // Gán lại giá trị column tránh bị lệch cột tổng tiền
      if (value == 2) {
        proxy.model.columnDetails = initGridColumnDetail();
      }
    };
    const changeTab3GroupTax = () => {
      tab3_group_tax.value = !tab3_group_tax.value;
    };
    const changeTab3ReturnOrg = () => {
      tab3_return_org.value = !tab3_return_org.value;
    };
    const details = ref([]);
    //Param dùng cho form tìm nhanh
    const quickSearchParam = reactive({
      Project: {
        isFilter: true,
        filterFunc: x => !x.inactive && !x.is_parent && x.object_type == 1 && x.project_code != '<< Không chọn >>',
      },
      collectionAgency: {
        titleSearch: 'cơ quan thu',
        payload: {
          sort: 'code',
          filter: [],
        },
        module: 'collectionAgency',
        idField: 'id',
      },
      StateBank: {
        titleSearch: 'mã ngân hàng, kho bạc',
        payload: {
          sort: 'state_bank_code',
        },
        module: 'stateBank',
        idField: 'state_bank_id',
        alwayTakeColumns: 'inactive',
      },
    });
    const {getModuleByRefType} = useInforCommons();
    const {comboboxLoadData} = useRemoteCombobox();

    // cấu hình column dropdown của combo
    const {bankInfoColumns, accountingObjectCustomColumns, collectionAgencyColumns} = useComboboxColumns();
    const {
      onProjectCommonComboboxLoadData,
      onBankInfoComboboxLoadData,
      onAccountingObjectComboboxLoadData,
      onStateBankComboboxLoadData,
      onCollectionAgencyComboboxLoadData,
    } = useInitActionCombo(comboboxDataRemote, comboboxLoadData);

    /**
     * edit VQDUC: 12.06.2023
     * lấy mặc định tên đơn vị và mã số thuế trong dboption
     */
    onMounted(() => {
      proxy.$store.dispatch('dbOption/getDbOptions').then(x => {
        model.company_name = x.CompanyName;
        model.company_tax_code = x.CompanyTaxCode;
      });
      proxy.isPrintGrid = proxy._formParam?.isPrintGrid;
      proxy.model.add_sec_info = 'Yêu cầu phát hành sec cho';
    });

    /**
     * Thực hiện load data
     */
    async function show() {
      // Focus vào ô input đầu tiên của form
      this.focusFirstControl();

      //Cập nhật dữ liệu vào model
      this.bindData({});
    }

    async function bindData(data) {
      let dbOptions = {...proxy.$store.state.dbOption.dbOptions};
      let voucher = proxy._report.dataModel || proxy._report.dataVoucher.data;
      if (voucher != null) {
        data.contract_template = data.contract_template || voucher.bu_commitment_request_ref_no;
        data.contract_perform = data.contract_perform || voucher.bu_commitment_request_ref_no;
        data.posted_year = voucher.posted_date.getFullYear();
        // Lấy số chứng từ
        data.ref_no = voucher.ref_no;

        // Lấy thông tin đơn vị nhận tiền, địa chỉ
        if (
          [proxy.$ms.constant.RefType.BADeposit, proxy.$ms.constant.RefType.BUTransferDeposit].includes(
            voucher.ref_type,
          )
        ) {
          data.organization_name = dbOptions.CompanyName;
          data.organization_address = dbOptions.CompanyAdrress;
        }
        if (
          [
            proxy.$ms.constant.RefType.BUPlanWithdrawDeposit,
            proxy.$ms.constant.RefType.BUTransferSalary,
            proxy.$ms.constant.RefType.BUPlanWithdrawTransfer,
            proxy.$ms.constant.RefType.BUTransfer,
            proxy.$ms.constant.RefType.BUTransferPurchase,
            proxy.$ms.constant.RefType.BUTransferFixedAsset,
            proxy.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer,
            proxy.$ms.constant.RefType.BUTreasuryFundTransferInsurancePayment,
            proxy.$ms.constant.RefType.BUTreasuryFundTransferSalary,
          ].includes(voucher.ref_type)
        ) {
          data.organization_name = voucher.accounting_object_name;
          data.organization_address = voucher.accounting_object_address;
        }

        if (
          [proxy.$ms.constant.RefType.CAReceipt, proxy.$ms.constant.RefType.CAReceiptPlanWithdraw].includes(
            voucher.ref_type,
          )
        ) {
          data.accounting_object_receipt = voucher.accounting_object_name;
        }
        // Lấy tài khoản
        if ([proxy.$ms.constant.RefType.BADeposit].includes(voucher.ref_type)) {
          data.accounting_object_bank_account = voucher.bank_account;
          data.accounting_object_bank_name = voucher.bank_name;
        } else if (
          [
            proxy.$ms.constant.RefType.BUTransfer,
            proxy.$ms.constant.RefType.BUPlanWithdrawTransfer,
            proxy.$ms.constant.RefType.BUPlanWithdrawDeposit,
            proxy.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer,
            proxy.$ms.constant.RefType.BUTransferDeposit,
            proxy.$ms.constant.RefType.BUTransferPurchase,
            proxy.$ms.constant.RefType.BUTreasuryFundTransferInsurancePayment,
            proxy.$ms.constant.RefType.BUTransferSalary,
            proxy.$ms.constant.RefType.BUTransferInsurrance,
            proxy.$ms.constant.RefType.BUTransferFixedAsset,
            proxy.$ms.constant.RefType.BUTreasuryFundTransferSalary,
          ].includes(voucher.ref_type)
        ) {
          data.accounting_object_bank_account = voucher.accounting_object_bank_account;
          data.accounting_object_bank_name = voucher.accounting_object_bank_name;
        } else {
          data.accounting_object_bank_account = data.accounting_object_bank_account || '';
          data.accounting_object_bank_name = data.accounting_object_bank_name || '';
        }
        let dataVoucher = [];
        if (
          [
            proxy.$ms.constant.RefType.BUPlanWithdrawCash,
            proxy.$ms.constant.RefType.BUPlanWithdrawDeposit,
            proxy.$ms.constant.RefType.BUPlanWithdrawTransfer,
            proxy.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer,
          ].includes(data.ref_type)
        ) {
          voucher[proxy._formParam.detailKey]
            .sort(function (a, b) {
              return a.sort_order - b.sort_order;
            })
            .sort(function (a, b) {
              return a.budget_sub_kind_item_code - b.budget_sub_kind_item_code;
            })
            .sort(function (a, b) {
              return a.budget_chapter_code - b.budget_chapter_code;
            })
            .sort(function (a, b) {
              return a.budget_sub_item_code - b.budget_sub_item_code;
            })
            .forEach(x => {
              let item = {
                amount: x.amount,
                tax_amount: 0,
                ref_detail_id: x.ref_detail_id,
                payment_amount: x.amount,
                org_ref_detail_id: x.org_ref_detail_id,
                budget_chapter_code: x.budget_chapter_code,
                budget_sub_item_code: x.budget_sub_item_code,
                budget_sub_kind_item_code: x.budget_sub_kind_item_code,
              };
              dataVoucher.push(item);
            });
        } else {
          voucher.Parallels.filter(
            x =>
              (x.credit_account?.startsWith('0061') ||
                x.credit_account?.startsWith('0062') ||
                x.credit_account?.startsWith('00811') ||
                x.credit_account?.startsWith('00812') ||
                x.credit_account?.startsWith('00821') ||
                x.credit_account?.startsWith('00822') ||
                x.credit_account?.startsWith('0091') ||
                x.credit_account?.startsWith('0092') ||
                x.credit_account?.startsWith('0093') ||
                x.credit_account?.startsWith('00813') ||
                x.credit_account?.startsWith('00823')) &&
              x.state != proxy.$ms.constant.ModelState.Delete &&
              x.state != proxy.$ms.constant.ModelState.Empty,
          )
            .sort(function (a, b) {
              return a.sort_order - b.sort_order;
            })
            .sort(function (a, b) {
              return a.budget_sub_kind_item_code - b.budget_sub_kind_item_code;
            })
            .sort(function (a, b) {
              return a.budget_chapter_code - b.budget_chapter_code;
            })
            .sort(function (a, b) {
              return a.budget_sub_item_code - b.budget_sub_item_code;
            })
            .forEach(x => {
              x.tax_amount = 0;
              x.payment_amount = x.amount;
              dataVoucher.push(x);
            });
        }
        if (JSON.stringify(dataVoucher) == JSON.stringify(data.Details)) {
          details.value = JSON.parse(data.JsonDetail || JSON.stringify(dataVoucher));
        }
        //ntchuyen 04.05.2023: Nếu là convert từ desktop sang thì luôn lấy dữ liệu ở JsonDetail nếu có
        else if (data.isDataConvert) {
          details.value = JSON.parse(data.JsonDetail || JSON.stringify(dataVoucher));
        } else {
          details.value = JSON.parse(JSON.stringify(dataVoucher));
        }
        data.Details = JSON.parse(JSON.stringify(dataVoucher));
      }
      defaultData(data);
      data.oldSummarySame = data.is_summary_same;
      proxy.super('bindData', baseVoucherReportParam, data);

      if (proxy.caseRefType1) {
        proxy.model.hasChooseProjectParam = true;
      }
    }
    function defaultData(data) {
      data.PaymentMethod =
        data.PaymentMethod ||
        ([
          proxy.$ms.constant.RefType.BUPlanWithdrawCash,
          proxy.$ms.constant.RefType.CAReceipt,
          proxy.$ms.constant.RefType.CAReceiptPlanWithdraw,
        ].includes(data.ref_type)
          ? proxy.$ms.constant.PaymentMethod.CashKB
          : proxy.$ms.constant.PaymentMethod.Transfer);
      data.add_sec_info = 'Yêu cầu phát hành sec cho';
    }
    // const columnDetails = reactive(initGridColumnDetail());
    function initGridColumnDetail() {
      return [
        {
          caption: 'Mã NDKT',
          title: 'Mã nội dung kinh tế',
          dataField: 'budget_sub_item_code',
          columnType: proxy.$ms.constant.ColumnType.Text,
          width: 90,
          editable: false,
        },
        {
          caption: 'Mã chương',
          dataField: 'budget_chapter_code',
          width: 90,
          columnType: proxy.$ms.constant.ColumnType.Text,
          editable: false,
        },
        {
          caption: 'Mã ngành KT',
          title: 'Mã ngành kinh tế',
          dataField: 'budget_sub_kind_item_code',
          width: 100,
          columnType: proxy.$ms.constant.ColumnType.Text,
          editable: false,
        },
        {
          caption: 'Tổng số tiền',
          dataField: 'amount',
          width: 180,
          editable: false,
          columnType: proxy.$ms.constant.ColumnType.Number,
          formatType: proxy.$ms.constant.FormatType.Amount,
          summaryType: proxy.$ms.constant.SummaryType.Sum,
        },
        {
          caption: 'Nộp thuế',
          dataField: 'tax_amount',
          width: 180,
          editable: true,
          columnType: proxy.$ms.constant.ColumnType.Number,
          formatType: proxy.$ms.constant.FormatType.Amount,
          summaryType: proxy.$ms.constant.SummaryType.Sum,
        },
        {
          caption: 'Thanh toán cho ĐV hưởng',
          title: 'Thanh toán cho đơn vị hưởng',
          dataField: 'payment_amount',
          autoResize: true,
          editable: true,
          columnType: proxy.$ms.constant.ColumnType.Number,
          formatType: proxy.$ms.constant.FormatType.Amount,
          summaryType: proxy.$ms.constant.SummaryType.Sum,
        },
      ];
    }

    const projectColumns = [
      {
        title: 'Mã CTMT',
        dataField: 'project_code',
        width: 140,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên CTMT',
        dataField: 'project_name',
        width: 300,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ];

    const stateTreasuryColumns = [
      {
        title: 'Mã KBNN',
        dataField: 'state_bank_code',
        width: 140,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'KBNN hạch toán khoản thu',
        dataField: 'state_bank_name',
        width: 300,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ];
    const changeDataBusiness = async ($grid, col, rowIndex, metaData, callbackUpdateRow) => {
      const {dataField} = col;
      let rowData = $grid.dataView[rowIndex]; //lấy ra dữ liệu của hàng đang sửa
      switch (dataField) {
        case 'tax_amount':
          callbackUpdateRow(
            {
              payment_amount: (rowData.amount ?? 0) - (rowData.tax_amount ?? 0),
            },
            rowIndex,
          );
          break;

        case 'payment_amount':
          callbackUpdateRow(
            {
              tax_amount: (rowData.amount ?? 0) - (rowData.payment_amount ?? 0),
            },
            rowIndex,
          );
          break;
      }
    };

    async function commandClick(command) {
      const me = proxy;
      switch (command) {
        case this.$ms.constant.Command.Ok:
          if (!model.collection_agency_code && selectedTabMain.value != 1) {
            selectedTabMainHandler(1);
            proxy.commandClick(me.$ms.constant.Command.Ok);
            return;
          }
          await me.submitGridEditor();
          // validate control
          if (!me.validateComponents()) {
            nextTick(() => {
              me.focusFirstError();
            });
            return;
          }
          commonFn.mask();
          me.beforePrintVoucher();

          // dtnga3 (30.08.2023) gán thêm vào trường cũ để sử dụng và k ảnh hưởng ở báo cáo, xuất dvc, ...
          model.receipt_agency_code = model.collection_agency_code;
          model.receipt_agency_name = model.collection_agency_name;

          model.JsonDetail = JSON.stringify(details.value);
          model.$DataDetail = JSON.stringify(
            details.value.map(x => ({
              ref_detail_id: x.ref_detail_id,
              tax_amount: x.tax_amount,
            })),
          );
          model.DataDetail = model.$DataDetail;
          model.$RowPerPage = model.repeat_title_signature ? model.row_per_page : 0;
          // model.$RowPerPage = 0;
          model.row_per_page_dynamic = model.repeat_title_signature ? model.row_per_page : 0;
          model.font_size_dynamic = model.has_font_size ? model.font_size : 10;
          model.$AddEmptyRow = model.repeat_title_signature ? model.add_empty_row : 0;
          model.$IsSummarySame = model.is_summary_same;
          model.$AddInfo = model.use_add_info ? model.add_info : '';
          model.$AddSecInfo = model.use_sec ? model.add_sec_info : '';
          model.$ShowContent = model.payment_content;
          model.$SummaryBy = model.add_row ? model.add_group : '';
          model.$SummaryMinTwoRow = model.add_row ? model.show_min_two_row : false;
          model.$IsGroupBudgetProvide = model.is_group_budget_provide;
          model.$IsSummaryBudgetProperty = model.is_summary_budget_property;

          //Lưu lại params vào index db => load lại lần sau
          this._indexDb.set(this._formName + '_' + this._formParam.report_id, this.model);

          model.sortColumn = model.sortColumn || JSON.stringify(columnC202a);
          let sortColumnParse = JSON.parse(model.sortColumn);
          sortColumnParse.forEach(x => x.sort_type = x.sort_type || 2);
          model.sortColumn = JSON.stringify(sortColumnParse); // Sửa lỗi nếu để trống thì sửa về thành Tăng dần
          model.OrderVoucher = JSON.parse(model.sortColumn)
            .map(x => `${x.dataField} ${x.sort_type == 1 ? 'DESC' : 'ASC'}`)
            .join(',');
          model.$OrderVoucher = model.OrderVoucher;

          let dataModel = _.cloneDeep(proxy._report.dataModel);
          if (proxy.details?.length > 0) {
            dataModel.DetailReport = proxy.details.filter(
              x => x.state != proxy.$ms.constant.ModelState.Delete && x.state != proxy.$ms.constant.ModelState.Empty,
            );
          }
          if (proxy._report.dataVoucher?.data) {
            proxy._report.dataVoucher.data.DetailReport = proxy.details;
          }
          proxy.model.add_sec_info = proxy.addSecInfo;

          popupUtil.show('ReportOfflineDesigner', {
            dataVoucher: proxy._report.dataVoucher,
            param: proxy.model,
            report: proxy._report.report,
            dataModel: dataModel,
          });
          proxy.hide();
      }
    }
    /**
     * @private
     * Lấy tham số khi mở form chi tiết
     * */
    function getDetailParameter(formName, mode, defaultData) {
      const me = proxy;

      let param = {
        data: _.cloneDeep(defaultData) || null,
      };

      switch (mode) {
        case me.$ms.constant.FormState.Duplicate:
        case me.$ms.constant.FormState.Edit:
        case me.$ms.constant.FormState.View:
          param.id = proxy._formParam.id;
          break;
      }

      param.mode = mode;
      param.editMode = proxy._formParam.editMode;
      param.submit = proxy._formParam.submit;
      param.hasBindFormData = true;
      me.customDetailParam(param);

      return param;
    }
    const {extendFilter} = usefilterActionCombo();
    function customPayloadProject(payload) {
      let filter = JSON.parse(payload?.filter || '[]');
      let selectedNone = {
        Field: 'project_code',
        Operator: '!=',
        Value: '<< Không chọn >>',
      };
      filter.push(selectedNone);

      payload.filter = extendFilter(payload.filter, filter);
      return payload;
    }

    /**
     * Hàm custom thêm Tất cả, Tổng hợp
     */
    const addDataCombo = function (key) {
      let data = [];
      let custom;
      switch (key) {
        case 'project':
          data = [proxy.$ms.constant.SpecialValue.NoneId];
          break;
        default:
          data = [proxy.$ms.constant.SpecialValue.AllId];
      }
      return {
        callBackFn: OperationUtil.addSpecialValue(key, {data, custom}),
      };
    };

    const selectedOrganization = ({newData}, me) => {
      if (newData) {
        me.model.organization_name = newData.accounting_object_name;
        me.model.organization_address = newData.address;

        // Case riêng trường hợp: Tăng TSCĐ từ QLTS.VN, Đánh giá lại TSCĐ từ QLTS.VN, Đánh giá lại TSCĐ
        if (
          [
            proxy.$ms.constant.RefType.FAVoucherIncreament,
            proxy.$ms.constant.RefType.FAVoucherAdjustment,
            proxy.$ms.constant.RefType.FAAdjustment,
          ].includes(me.model.ref_type)
        ) {
          if (newData.is_employee) {
            proxy.model.accounting_object_bank_account = newData.bank_account;
            proxy.model.accounting_object_bank_name = newData.bank_name;
          } else {
            let payload = {};

            payload.skip = 0;
            payload.sort = 'bank_code';
            payload.take = 10;

            payload.sort = 'bank_code';
            payload.column = 'bank_account, bank_code, bank_name';
            payload.columns = 'bank_account, bank_name';
            let extend = [
              {
                Field: 'accounting_object_id',
                Value: newData.accounting_object_id,
              },
            ];
            payload.filter = extendFilter(payload.filter, extend);
            accountingObjectInfoAPI.getComboboxPaging(payload).then(result => {
              if (result && result.length) {
                const dataBinding = result[0];
                proxy.model.accounting_object_bank_account = dataBinding.bank_account;
                proxy.model.accounting_object_bank_name = dataBinding.bank_name;
              } else {
                proxy.model.accounting_object_bank_account = '';
                proxy.model.accounting_object_bank_name = '';
              }
            });
          }
        }
      } else {
        me.model.organization_name = '';
        me.model.organization_address = '';
      }
    };

    const selectedAccountingObject = ({newData}, me) => {
      if (newData) {
        me.model.accounting_object_name = newData.accounting_object_name;
        me.model.identification_number = newData.identification_number;
        me.model.issue_date = newData.issue_date;
        me.model.issue_by = newData.issue_by;
      } else {
        me.model.accounting_object_name = '';
        me.model.identification_number = '';
        me.model.issue_date = '';
        me.model.issue_by = '';
      }
    };

    const selectedStateTreasury = ({newData}, me) => {
      if (newData) {
        me.model.state_bank_name = newData.state_bank_name;
        me.model.state_bank_code = newData.state_bank_code;
        me.model.state_bank_id = newData.state_bank_id;
      } else {
        me.model.state_bank_name = '';
      }
    };

    /**
     * set giá trị model khi thay đổi dữ liệu Mã cơ quan thu
     * dtnga3 (30.08.2023)
     */
    const selectedCollectionAgency = ({newData}) => {
      if (newData) {
        proxy.model.collect_administration_agency = newData.name;
        proxy.model.collection_agency_name = newData.name;
      } else {
        proxy.model.collect_administration_agency = '';
        proxy.model.collection_agency_name = '';
      }
    };

    const {selectedBank} = useInforCommons();

    const selectedProject = ({newData}, me) => {
      if (newData) {
        me.model.project_name = newData.project_name;
      } else {
        me.model.project_name = '';
        me.model.project_code = '';
        me.model.project_id = null;
      }
    };

    function changeShowRow() {
      if (model.show_add_row) {
        model.is_group_budget_provide = false;
      }
    }

    function changeGroupDate() {
      if (model.is_group_budget_provide) {
        model.show_add_row = false;
      }
    }
    const caseRefType1 = computed(() => {
      return [
        proxy.$ms.constant.RefType.CAReceiptPlanWithdraw,
        proxy.$ms.constant.RefType.BADeposit,
        proxy.$ms.constant.RefType.CAReceipt,
        proxy.$ms.constant.RefType.FAVoucherIncreament,
        proxy.$ms.constant.RefType.FAVoucherAdjustment,
        proxy.$ms.constant.RefType.FAAdjustment,
      ].includes(proxy.model.ref_type);
    });

    const caseRefType2 = computed(() => {
      return [
        proxy.$ms.constant.RefType.FAVoucherIncreament,
        proxy.$ms.constant.RefType.FAVoucherAdjustment,
        proxy.$ms.constant.RefType.FAAdjustment,
      ].includes(proxy.model.ref_type);
    });

    const IsDetailbyBudgetProvidence = computed(() => {
      let dbOptions = {...proxy.$store.state.dbOption.dbOptions};
      return dbOptions.IsDetailbyBudgetProvidence;
    });

    /**
     * override gán dữ liệu chung theo ref_type
     * dqdat1 17.04.2023
     */
    function assignFormatRecentData(data, format) {
      let recent = JSON.parse(format);
      if (recent) {
        Object.assign(data, recent.dataRefType);
      }
    }
    const totalTaxAmount = ref(0);
    watch(
      () => details.value,
      value => {
        if (value) {
          totalTaxAmount.value = value
            .filter(x => x.state !== proxy.$ms.constant.ModelState.Delete)
            .reduce((pre, cur) => {
              return pre + (cur['tax_amount'] || 0);
            }, 0);

          if (totalTaxAmount.value > 0) {
            proxy.addObserveControl(true);
          }
        }
      },
      {deep: true},
    );

    function addObserveControl(forceAdd = false) {
      if (!this._observeControls || forceAdd) {
        this._observeControls = [];
        const $el = this.$el;
        const $controls = $el.querySelectorAll('.ms-validate');
        if ($controls && $controls.length > 0) {
          $controls.forEach(item => {
            if (typeof item.getVueInstance === 'function') {
              this._observeControls.push(item.getVueInstance());
            }
          });
        }
      }
    }

    function validateComponents() {
      const me = proxy;
      let controls = me._observeControls.filter(
        x =>
          x.$el.offsetWidth ||
          x.$el.offsetHeight ||
          x.$el.getClientRects().length ||
          /** Xử lý validate control khi ẩn */
          (x.rules && Array.isArray(x.rules) && x.rules?.some(x => x.hide)),
      );
      if (controls.length > 0) {
        const errors = controls.map(x => {
          if (typeof x.validate === 'function') {
            return x.validate();
          }
          return '';
        });
        if (errors.some(x => x)) {
          proxy.selectedTabMainHandler(1);
        }
        return !errors.some(x => x);
      }
      return true;
    }
    function inputCollectionAgency(value) {
      proxy.model.collection_agency_code = value;
    }

    return {
      proxy,
      addSecInfo,
      stateBankData,
      collectionAgencyData,
      show,
      model,
      comboboxDataRemote,
      selectedTabMainHandler,
      selectedTabMain,
      tab3_group_tax,
      tab3_return_org,
      changeTab3GroupTax,
      changeTab3ReturnOrg,
      bindData,
      // columnDetails,
      details,
      changeDataBusiness,
      commandClick,
      caseRefType1,
      caseRefType2,
      projectColumns,
      bankInfoColumns,
      onProjectCommonComboboxLoadData,
      onBankInfoComboboxLoadData,
      customPayloadProject,
      addDataCombo,
      accountingObjectCustomColumns,
      selectedAccountingObject,
      onAccountingObjectComboboxLoadData,
      selectedOrganization,
      collectionAgencyColumns,
      onStateBankComboboxLoadData,
      stateTreasuryColumns,
      selectedStateTreasury,
      selectedCollectionAgency,
      changeShowRow,
      changeGroupDate,
      selectedProject,
      selectedBank,
      getDetailParameter,
      IsDetailbyBudgetProvidence,
      assignFormatRecentData,
      totalTaxAmount,
      addObserveControl,
      validateComponents,
      onCollectionAgencyComboboxLoadData,
      quickSearchParam,
      reportIdCommon,
      isPrintGrid,
      inputCollectionAgency,
    };
  },
  computed: {
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
  },
});
</script>
<style lang="scss">
.report-param-c202bNSND112020-withBankAccount {
  .report-title {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid $color-bg-grey;

    .title-control-group {
      background-color: $ms-grey;
      cursor: pointer;
      font-size: $font-size;
      height: 100%;
      padding: 10px 15px;
      color: $grey-smoke;
      border-bottom: 1px solid $color-bg-grey;
      &.active {
        color: $black;
        border-bottom: 2px solid $primary;
        font-weight: $font-weight-semi-bold;
      }
    }
  }
  .report-body {
    display: flex;
    flex-direction: column;
    .report-tab {
      flex: 1;
      overflow: auto;
      &.tab-1 {
      }
      &.tab-2 {
        .ms-th-title.has-sort {
          padding-right: 10px;
        }
        .ms-editor.flex-column.h-auto {
          height: calc(100% - 70px);
        }
      }
      &.tab-3 {
        .title-3 {
          align-items: center;
          cursor: default;
          font-weight: $font-weight-semi-bold;
          margin-left: -8px;
        }
        .icon-combo--dropdown {
          border-radius: 0 4px 4px 0;
          width: $input-height;
          height: $input-height;
          position: relative;

          &:before {
            content: '';
            position: absolute;
            width: $input-height;
            height: $input-height;
            display: inline-block;
            background: transparent url($ms-image-sprites) no-repeat -334px -45px;
            top: 0px;
            left: 0px;
            transform: rotate(270deg);
            transition: all 0.3s ease;
          }
          &.multiple {
            position: sticky;
            top: 0px;
          }

          &.expand {
            &:before {
              transform: rotate(0deg);
            }
          }
        }
      }
      &.tab-4 {
      }
    }
    .seperator-line {
      border-top: 1px solid $secondary;
      width: 100%;
      &.tab-3 {
        border-top: 1px solid $secondary-active;
      }
    }
    .control-title {
      font-weight: $font-weight-medium;
    }
  }

  .ms-checkbox {
    &.left {
      margin-left: -4px !important;
    }
    input[type='checkbox']:disabled {
      background-color: $ms-grey;
    }
  }
  .align-center {
    align-items: center;
  }
  .footer-total-count .text-left {
    font-weight: $font-weight-semi-bold;
  }
  .ms-footer th {
    background: $ms-grey !important;
  }
}
</style>
